import ModuleManager from "../../../framework/core/module_manager";

const { ccclass, property, menu, requireComponent, executeInEditMode } = cc._decorator;

@ccclass
export default class TableMenu extends cc.Component{

    @property(cc.Node)
    nodeMask: cc.Node = null

    @property(cc.Node)
    nodeFreeBtn: cc.Node = null

    @property(cc.Node)
    nodeLeaveBtn: cc.Node = null
    
    @property(cc.Node)
    nodeSettingBtn: cc.Node = null
    
    @property(cc.Node)
    nodeIntrustBtn: cc.Node = null
    
    @property(cc.Node)
    nodeRuleBnn: cc.Node = null        

    protected mIntentData: any = null

    onLoad(){
        this.registUiBtnClick()
    }

    onDestroy(){
        this.unregistUiBtnClick()
    }

    protected registUiBtnClick(){
        this.nodeMask && this.nodeMask.on('click', this.onClickMask, this)
        this.nodeFreeBtn && this.nodeFreeBtn.on('click', this.onClickFreeBtn, this)
        this.nodeLeaveBtn && this.nodeLeaveBtn.on('click', this.onClickLeaveBtn, this)
        this.nodeSettingBtn && this.nodeSettingBtn.on('click', this.onClickSettingBtn, this)
        this.nodeIntrustBtn && this.nodeIntrustBtn.on('click', this.onClickIntrustBtn, this)
        this.nodeRuleBnn && this.nodeRuleBnn.on('click', this.onClickRuleBtn, this)
    }

    protected unregistUiBtnClick(){
        this.nodeMask && this.nodeMask.off('click', this.onClickMask, this)
        this.nodeFreeBtn && this.nodeFreeBtn.off('click', this.onClickFreeBtn, this)
        this.nodeLeaveBtn && this.nodeLeaveBtn.off('click', this.onClickRuleBtn, this)
        this.nodeSettingBtn && this.nodeSettingBtn.off('click', this.onClickSettingBtn, this)
        this.nodeIntrustBtn && this.nodeIntrustBtn.off('click', this.onClickIntrustBtn, this)
        this.nodeRuleBnn && this.nodeRuleBnn.off('click', this.onClickRuleBtn, this)
    }

    protected onClickMask(){
        let callback = this.mIntentData.onClickMaskBtn
        if(callback){
            callback()
            return
        }
        this.showMenu(false)
    }

    protected onClickFreeBtn(){
        let callback = this.mIntentData.onClickFreeRoomBtnCallback
        if(callback){
            callback()
            return
        }
    }

    protected onClickLeaveBtn(){
        let callback = this.mIntentData.onClickLeaveBtnCallback
        if(callback){
            callback()
            return
        }
    }

    protected onClickSettingBtn(){
        let callback = this.mIntentData.onClickSettingBtnCallback
        if(callback){
            callback()
            return
        }        
    }

    protected onClickIntrustBtn(){
        let callback = this.mIntentData.onClickIntrustBtnCallback
        if(callback){
            callback()
            return
        }
    }

    protected onClickRuleBtn(){
        let callback = this.mIntentData.onClickRuleBtnCallback
        if(callback){
            callback()
            return
        }
    }

    showMenu(show: boolean, intentData?: any){
        this.node.active = show || false
        if(show){
            this.mIntentData = intentData
            this.showBtn(this.nodeFreeBtn, intentData.showFreeBtn)
            this.showBtn(this.nodeLeaveBtn, intentData.showLeaveBtn)
            this.showBtn(this.nodeSettingBtn, intentData.showSettingBtn)
            this.showBtn(this.nodeIntrustBtn, intentData.showIntrustBtn)
            this.showBtn(this.nodeRuleBnn, intentData.showRuleBtn)
        }                
    }

    protected showBtn(node: cc.Node, show: boolean){
        node && (node.active = show || false)
    }
}
